
        <div class="modal-header panel-heading">
            <h2 class="modal-title">{{"contractDetails.createNewTitle" | translate}}</h2>
            <button type="button" class="close" (click)="onClose()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            @if(ContractDetailsForm) {
            <form [formGroup]="ContractDetailsForm">
                <div class="form-group mt-lg px-2">
                    <div class="row">
                        <div class="col-6 mt-3">
                            <div class="form-label">
                                {{ "labels.startDate" | translate }}
                            </div>
                            <input class="form-control" placeholder="dd-mm-yyyy" name="startDate" formControlName="startDate" ngbDatepicker
                                (click)="startPicker.toggle()" #startPicker="ngbDatepicker">
                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "labels.endDate" | translate }}
                            </div>
                            <input class="form-control" placeholder="dd-mm-yyyy" name="endDate" formControlName="endDate" ngbDatepicker
                                (click)="endPicker.toggle()" #endPicker="ngbDatepicker">

                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "contractDetails.form.poNumber" | translate }}
                            </div>
                            <input type="text" class="form-control" formControlName="po">

                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "contractDetails.form.caseNumber" | translate }}
                            </div>
                            <input type="text"  class="form-control" formControlName="caseNumber">
                        </div>
                        <div class="col-6  mt-3">
                            <div class="form-label">
                                {{ "contractDetails.form.budget" | translate }}
                            </div>
                            <input type="text" class="form-control" formControlName="budget">
                        </div>
                        <div class="col-6"></div>
                        <div class="col-12  mt-3">
                            <div class="form-label">
                                {{ "contractDetails.form.comment" | translate }}
                            </div>
                            <quill-editor formControlName="comment" format="html" [modules]="modules" [styles]="{ height: '150px' }" class="w-100"></quill-editor>
                        </div>
                        </div>

                </div>

            </form>
            }

        </div>
        <div class="contract-details-modal-footer">
            <button class="btn btn-primary ml-3" (click)="onSave()">
                {{ "labels.save" | translate }}
            </button>
            <button class="btn btn-danger ml-3" (click)="onClose()">
                {{ "labels.cancel" | translate }}
            </button>
        </div>
